import React from "react";
import { Divider, Typography } from "antd";

const FormDivider = ({ title, ...props }) => (
  <Divider className="form-divider" orientation="left" {...props}>
    <div className="form-divider-text">{props.children}</div>
  </Divider>
);
export default FormDivider;
